import script from "./courseStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./courseStatistics.vue?vue&type=script&setup=true&lang=js"

import "./courseStatistics.vue?vue&type=style&index=0&id=7aa4d83d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aa4d83d"]])

export default __exports__